<template>
  <div>
    <div class="align-left margin-bottom-2 margin-top-3">
      <div
        class="align-left margin-bottom-2 margin-top-3"
        style="display: flex;justify-content: left; gap: 2rem;"
      >
        <router-link
          tag="button"
          class="button-gemnote button-gemnote--small"
          :to="{ name: 'AddPaymentMethod' }"
        >
          <span>+ Add new credit card</span>
        </router-link>
        <router-link
          tag="button"
          class="whitebutton-gemnote whitebutton-gemnote--small"
          :to="{ name: 'AddInvoicePaymentMethod' }"
        >
          <span>Pay by invoice</span>
        </router-link>
      </div>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="zeroStateRows"
      styleClass="vgt-table striped"
      row-style-class="blur-row"
      style="width: 100%;"
    >
      <template slot="table-row" slot-scope="zeroStateRows">
        <span v-if="zeroStateRows.column.field === 'isPrimary'">
          <p style="text-align:center; font-weight: 600">Primary Card</p>
        </span>
        <span v-else-if="zeroStateRows.column.field === 'brand'">
          <img :src="zeroStateRows.row.image" class="brand-icon" />
        </span>
        <template v-else-if="zeroStateRows.column.field === 'canBeRemoved'">
          <p style="font-weight: 600">Remove Card</p>
        </template>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'PaymentMethodsZeroState',
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: '',
          field: 'isPrimary',
          sortable: false,
          width: '20%'
        },
        {
          label: '',
          field: 'brand',
          sortable: false,
          width: '20%'
        },
        {
          label: '',
          field: 'lastFour',
          sortable: false,
          width: '20%'
        },
        {
          label: '',
          field: 'expirationDate',
          sortable: false,
          width: '20%'
        },
        {
          label: '',
          field: 'canBeRemoved',
          sortable: false,
          width: '20%'
        }
      ],
      zeroStateRows: [
        {
          isPrimary: true,
          image:
            'https://img.favpng.com/18/7/10/computer-icons-scalable-vector-graphics-bank-clip-art-png-favpng-7jAPKVG4TT32mr1GSE2QsDKL2.jpg',
          cardNumber: 'Card Number****XXXX',
          expirationDate: 'Expiration Date'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.button-gemnote,
.whitebutton-gemnote {
  height: 2.5rem;
  font-size: 0.813rem;
  width: auto;
  padding: 0 1.25rem;
}

h5 {
  margin: 3rem;
}

.brand-icon {
  height: 50px;
}
</style>
